/**
 * JSON-LD Schema Block
 *
 * Injection block that generates structured data (schema.org JSON-LD)
 * from property data and collections. Renders a <script> tag in the page
 * head for search engine rich results.
 */

import type { BlockDefinition } from '../../types';
import { JsonLdSchemaComponent } from './component';
import { contentSchema } from './schema';

export const jsonLdSchemaBlock: BlockDefinition = {
  id: 'json-ld-schema',
  name: 'Multihub Site Schema',
  description: 'Structured data for search engines. Auto-generated from property data.',
  category: 'SEO',
  placement: 'injection',
  defaultScope: 'global',
  component: JsonLdSchemaComponent,
  contentSchema,
  tags: ['seo', 'schema', 'json-ld', 'structured-data', 'rich-results'],
};
